import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams
} from "@angular/common/http";
import { environment } from '../../environments/environment';
import { Observable, map } from 'rxjs';

import { Country } from '../_models/country.model';
import { Directory } from '../_models/directory.model';
import { PrescriptionPdv } from '../_models/prescription-pdv.model';
import { UserLog } from '../_models/user-log.model';
import { UnrecognizedItem } from '../_models/unrecognized-item.model';
import { UnlockResponse } from '../_models/unlock-response.model';
import { LockPageResponse } from '../_models/lock.model';
import { GroupCreated } from '../_models/group-created.model';
import { GroupUser } from '../_models/group-user.model';
import { GroupListItem } from '../_models/group-list-item.model';
import { PaginatedResponse } from '../_models/paginated-response.model';
import { PrescriptionItem } from '../_models/prescription-item.model';
import { NextPrescriptionResponse } from '../_models/next-prescription-response.model';
import { PrescriptionResponse } from '../_models/prescription-response.model';
import { ItemResponse } from '../_models/item-response.model';
import { LockPage } from '../_models/lock.model';
import { User } from '../_models/user.model';
import { Region } from '../_models/region.model';
import { IndexedDbService } from './indexed-db.service';
import { Group } from '../_models';
import { ValidacaoPrescriptionPendenteItem } from '../_models/prescription-validacao-pendentes-item.model';
import { PrescriptionValidacaoPendentesItemResponse } from '../_models/prescription-validacao-pendentes-item-response.model';
import { NextPrescriptionValidacaoPendentesItemResponse } from '../_models/next-prescription-validacao-pendentes-item-response.model';
import { PrescriptionImportErrorListItem } from '../_models/prescription-import-error.model';

@Injectable({
  providedIn: 'root'
})
export class JsonService {
  // OLD
  private itensUrl = `${environment.apiRoot}/group/list-prescriptions-by-user-email?userEmail=`; 
  // NEW
  private itensApiUrl = `${environment.apiRoot}/Group/list-prescriptions-by-groups`; 
  private itemNextUrl = `${environment.apiRoot}/Group/get-next-prescriptions-by-groups`;

  private itemUrl = `${environment.apiRoot}/prescription/readData?id=`; 
  private itemImageUrl = `${environment.apiRoot}/prescription/readData/image?id=`; 


  /* Prescrições com Validação de Api Maetro */
  private itensApiPendentesUrl = `${environment.apiRoot}/Group/list-prescriptions-pendentes-by-groups`; 
  private itemNextPendentesUrl = `${environment.apiRoot}/Group/get-next-prescriptions-pendentes`;
  private itemValidacaoPendentesUrl = `${environment.apiRoot}/prescription/readDataValidacaoPrescriptionPendentes`;
  

  private putUrl = `${environment.apiRoot}/prescription/review`;
  private cidadeUrl = `${environment.apiRoot}/prescription/getCidade`;
  private pdvUrl = `${environment.apiRoot}/prescription/getpdv`;
  private anoUrl = `${environment.apiRoot}/prescription/getAno`;
  private mesUrl = `${environment.apiRoot}/prescription/getMes`;
  private envioUrl = `${environment.apiRoot}/prescription/getEnvio`;
  private regiaoUrl = `${environment.apiRoot}/Region/listRegions`;
  private regiaoIdUrl = `${environment.apiRoot}/Region/ReadRegion`;
  private provedorUrl = `${environment.apiRoot}/prescription/getProvedor`;
  private countryUrl = `${environment.apiRoot}/Country/readCountry`;
  private statusUrl = `${environment.apiRoot}/prescription/list-status`;
  private countryListUrl = `${environment.apiRoot}/Country/listCountries`;
  private paisUrl = `${environment.apiRoot}/Country/listCountries`;
  private prescriptionPaisUrl = `${environment.apiRoot}/prescription/getPais`;
  private dashboardPrescricoesUrl = `${environment.apiRoot}/Dashboard/prescricoes-por-pais`;
  private dashboardRevisadasUrl = `${environment.apiRoot}/Dashboard/prescricoes-revisadas-por-pais`;
  private dashboardPrescricoesMesUrl = `${environment.apiRoot}/Dashboard/prescricoes-por-mes`;
  private dashboardRevisadasMesUrl = `${environment.apiRoot}/Dashboard/prescricoes-revisadas-por-mes`;
  private dashboardRevisadasRevisorUrl = `${environment.apiRoot}/Dashboard/revisadas-por-revisor`;
  private monitoramentoProcessosUrl = `${environment.apiRoot}/Prescription/monitoramento-processos`;
  private dashboardResumoBatchMesUrl         = `${environment.apiRoot}/Dashboard/resumo-batch-mes`;
  private dashboardResumoBatchPdvUrl         = `${environment.apiRoot}/Dashboard/resumo-batch-pdv`;
  private dashboardRelatorioIntervencoesUrl  = `${environment.apiRoot}/Dashboard/relatorio-intervencoes`;
  private prescriptionImportBatchListWithErrorUrl = `${environment.apiRoot}/PrescriptionImportBatch/list-with-error`;
  private prescriptionImportBatchDownloadUrl = `${environment.apiRoot}/PrescriptionImportBatch/`;
  private userUrl = `${environment.apiRoot}/user/get-all-permissions`;
  private groupListUrl = `${environment.apiRoot}/group/list-with-percentages`;
  private groupListUserResptUrl = `${environment.apiRoot}/group/list-with-responsible-percentages?email=`;
  
  private mediciUrl = `${environment.apiSimilaridade}/api/find_produto_all_es`;
  private especialidadeUrl = `${environment.apiSimilaridade}/api/find_especialidade_all_es`;
  private posologiaUrl = `${environment.apiSimilaridade}/api/find_posologia_all_es`;
  private medicoUrl = `${environment.apiSimilaridade}/api/find_medico_all`;
  private findMedicoUrl = `${environment.apiSimilaridade}/api/findMedico`;
  private findProdutoEsUrl = `${environment.apiSimilaridade}/api/find_produto_es`;
  private findInstituicaoUrl = `${environment.apiSimilaridade}/api/findInstituicao`;
  private medicoAttributesUrl = `${environment.apiSimilaridade}/api/find_medico_attributes `;
  private crmUrl = `${environment.apiSimilaridade}/api/find_crm_all_es`;
  private enderecoUrl = `${environment.apiSimilaridade}/api/find_endereco_all_es`;
  
  private sendCapturaUrl = `${environment.apiRoot}/prescription/generate-csv-by-country?requestMode=Manual`;
  private sendCapturaSelectedUrl = `${environment.apiRoot}/prescription/generate-csv?requestMode=Manual`;
  
  private listarGruposUlr = `${environment.apiRoot}/Group/listGroups`;
  private listarGruposPorPaisUrl = `${environment.apiRoot}/Group/list-by-country`;
  private listarUsersUlr = `${environment.apiRoot}/User/list`;
  private addUserToGroupUlr = `${environment.apiRoot}/Group/add-user`;
  private removeUserToGroupUlr = `${environment.apiRoot}/Group/remove-user`;
  private addUserResponsibleToGroupUlr = `${environment.apiRoot}/Group/add-userResponsible`;
  private removeUserResponsibleToGroupUlr = `${environment.apiRoot}/Group/remove-userResponsible`;
  private createGroupUlr = `${environment.apiRoot}/Group/create`;
  private changePrescriptionGroupUlr = `${environment.apiRoot}/group/move-prescription-list`;
  
  private registerUrl = `${environment.apiRoot}/User/register-user`;
  private unlockAll = `${environment.apiRoot}/PrescriptionBlocked/unlock`;
  private lockPageCreateUrl = `${environment.apiRoot}/PrescriptionBlocked/create`;
  private lockPageReadUrl = `${environment.apiRoot}/PrescriptionBlocked/read-by-prescription`;
  private unlockPageUrl = `${environment.apiRoot}/PrescriptionBlocked/unlock-prescription`;
  private getImageQualityUrl = `${environment.apiRoot}/Prescription/list-image-quality`;
  private getSearchFilenameUrl = `${environment.apiRoot}/Prescription/search-filenames`;
  private getSearchPdvUrl = `${environment.apiRoot}/Prescription/search-pdv`;
  private countWaitingPrescriptionByGroupUrl = `${environment.apiRoot}/Group/count-waiting-prescription-by-group`;
  private countIntegratedPrescriptionByGroupUrl = `${environment.apiRoot}/Group/count-integrated-prescription-by-group`;
  private countReviewedPrescriptionByGroupUrl = `${environment.apiRoot}/Group/count-reviewed-prescription-by-group`;
  private userLogUrl = `${environment.apiRoot}/UserPrescriptionSession/create-user-session`;
  private unrecongnizedUrl = `${environment.apiRoot}/UnrecognizedItem/list`;
  private groupDetailUrl = `${environment.apiRoot}/Group/read`;
  private groupListUsersUrl = `${environment.apiRoot}/Group/list-group-users`;
  private groupUpdateUrl = `${environment.apiRoot}/Group/update`;
  private groupDeleteUrl = `${environment.apiRoot}/Group/delete`;
  private groupToggleActiveUrl = `${environment.apiRoot}/Group/toggle-active-group`;
  private groupCrToggleActiveUrl = `${environment.apiRoot}/Group/toggle-active-country-region`;
  private groupCrUserToggleActiveUrl = `${environment.apiRoot}/Group/toggle-active-country-region-user`;
  private groupCrCheckPendingUrl = `${environment.apiRoot}/Group/check-gcru-prescriptions-pending`;

  private directoryListUrl = `${environment.apiRoot}/DirectoryConfig/list`;
  private directoryCreateUrl = `${environment.apiRoot}/DirectoryConfig/create`;
  private directoryDetailUrl = `${environment.apiRoot}/DirectoryConfig/read`;
  private directoryUpdateUrl = `${environment.apiRoot}/DirectoryConfig/update`;
  private directoryDeleteUrl = `${environment.apiRoot}/DirectoryConfig/delete`;
  private directoryUploadPdvUrl = `${environment.apiRoot}/DirectoryConfig/upload-pdvs`;
  private directoryDownloadPdvTemplateUrl = `${environment.apiRoot}/DirectoryConfig/download-pdv-template`;
  private directoryCountPdvUrl = `${environment.apiRoot}/DirectoryConfig/count-pdvs`;
  private directoryListMonthFoldersUrl = `${environment.apiRoot}/DirectoryConfig/list-month-folders`;

  private pdvListUrl = `${environment.apiRoot}/PrescriptionPDV/list`;
  private pdvDetailUrl = `${environment.apiRoot}/PrescriptionPDV/read`;
  private pdvCreateUrl = `${environment.apiRoot}/PrescriptionPDV/create`;
  private pdvUpdateUrl = `${environment.apiRoot}/PrescriptionPDV/update`;
  private pdvDeleteUrl = `${environment.apiRoot}/PrescriptionPDV/delete`;
  private pdvUploadUrl = `${environment.apiRoot}/PrescriptionPDV/upload-pdvs`;
  private pdvDownloadTemplateUrl = `${environment.apiRoot}/PrescriptionPDV/download-template`;

  private countReviewedPrescriptionByMyGroupUrl = `${environment.apiRoot}/Group/count-reviewed-prescription-today`;
  private countReviewedPrescriptionTodayUrl = `${environment.apiRoot}/Group/count-reviewed-prescription-today-by-current-user`;
  //private userPerformanceTrackingUrl = `${environment.apiRoot}/UserPrescriptionTracking/report`;
  private userPerformanceTrackingUrl = `${environment.apiRoot}/UserPrescriptionTracking/view_UserPrescriptionTrackingSummary`;
  private userPrescriptionsCountryReviewerUrl = `${environment.apiRoot}/UserPrescriptionTracking/view_prescriptions_by_country_reviewer`;
  private cookieCreateUrl = `${environment.apiRoot}/Cookie/set`;
  private cookieReadUrl = `${environment.apiRoot}/Cookie/get`;
  private cookieDeleteUrl = `${environment.apiRoot}/Cookie/delete`;
  
  constructor(
    private http: HttpClient,
    private db: IndexedDbService
  ) { }

  private createUserFormData(): FormData {
    const formData = new FormData();
    formData.append('formDataSender', 'user');
    return formData;
  }

  async getToken(): Promise<string | null> {
    const token = await this.db.getData('id_token');
    return token;
  }
  
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + this.getToken(),
      'Access-Control-Allow-Origin': '*'
    });
  }

  cookieCreate(name: string, value: string) {
    let url = this.cookieCreateUrl + '?name=' + name + '&value=' + value;
    return this.http.post<any>(url, { headers: this.getHeaders(), withCredentials: true });
  }

  cookieGet(name: string) {
    return this.http.get<any>(`${this.cookieReadUrl}?name=${name}`, { headers: this.getHeaders(), withCredentials: true } );
  }
/*
  cookieDelete(formData: FormData) {
    return this.http.delete<any>(this.cookieDeleteUrl, formData, { headers: this.getHeaders() });
  }
*/
  getReviewedPrescripitionsGroupCount(): Observable<number>{
    return this.http.get<number>(this.countReviewedPrescriptionByMyGroupUrl, { headers: this.getHeaders() });
  }

  getReviewedPrescripitionsTodayCount(): Observable<number>{
    return this.http.get<number>(this.countReviewedPrescriptionTodayUrl, { headers: this.getHeaders() });
  }

  userLog(formData: FormData) {
    return this.http.post<UserLog>(this.userLogUrl, formData, { headers: this.getHeaders() });
  }

  getUnrecognizedItems() {
    return this.http.get<UnrecognizedItem[]>(this.unrecongnizedUrl, { headers: this.getHeaders() });
  }

  getPrescriptionUnprocessedCount(): Observable<number>{
    return this.http.get<number>(this.countWaitingPrescriptionByGroupUrl, { headers: this.getHeaders() });
  }

  getPrescriptionReviewedCount(): Observable<number>{
    return this.http.get<number>(this.countReviewedPrescriptionByGroupUrl, { headers: this.getHeaders() });
  }

  getPrescriptionIntegratedCount(): Observable<number>{
    return this.http.get<number>(this.countIntegratedPrescriptionByGroupUrl, { headers: this.getHeaders() });
  }

  getImageQuality(): Observable<string[]> {
    return this.http.get<string[]>(this.getImageQualityUrl, { headers: this.getHeaders() });
  }

  unlockPage(id: string) {
    let formData = new FormData();
    formData.append('prescriptionId', id);
    let url = this.unlockPageUrl + '?prescriptionId=' + id;
    return this.http.put<UnlockResponse>(url ,formData, { headers: this.getHeaders() });
  }

  lockPageRead(id: string) {
    return this.http.get<LockPage>(this.lockPageReadUrl + '?id=' + id, { headers: this.getHeaders() });
  }

  lockPageCreate(formData: FormData) {
    return this.http.post<LockPageResponse>(this.lockPageCreateUrl, formData, { headers: this.getHeaders() });
  }

  unlockAllPage() {
    return this.http.post<UnlockResponse>(this.unlockAll, this.createUserFormData(), { headers: this.getHeaders() });
  }

  setUserRegister() {
    return this.http.post<User>(this.registerUrl, this.createUserFormData(), { headers: this.getHeaders() });
  }

  changeGroup(body: any): Observable<string[]> {
    return this.http.put<string[]>(this.changePrescriptionGroupUlr, body, { headers: this.getHeaders() });
  }
  listGroups(): Observable<Group[]> {
    return this.http.get<Group[]>(this.listarGruposUlr, { headers: this.getHeaders() });
  }

  listGroupsByCountry(countryCode: string): Observable<Group[]> {
    return this.http.get<Group[]>(this.listarGruposPorPaisUrl + '?countryCode=' + countryCode, { headers: this.getHeaders() });
  }
  createGroup(groupData: any): Observable<any> {
    return this.http.post<any>(this.createGroupUlr, groupData, { headers: this.getHeaders() });
  }

  listGroupUsers(onlyManaged: boolean = false) {
    let params = new HttpParams();
    if (onlyManaged) {
      params = params.append('onlyManaged', 'true');
    }
    return this.http.get<GroupUser[]>(this.listarUsersUlr, { headers: this.getHeaders(), params });
  }

  createAssociation(formData: FormData): Observable<number> {
    return this.http.put<number>(this.addUserToGroupUlr ,formData, { headers: this.getHeaders() });
  }

  removeAssociation(formData: FormData): Observable<number> {
    return this.http.put<number>(this.removeUserToGroupUlr ,formData, { headers: this.getHeaders() });
  }

  addUserResponsible(formData: FormData): Observable<number> {
    return this.http.put<number>(this.addUserResponsibleToGroupUlr ,formData, { headers: this.getHeaders() });
  }
 
  removeUserResponsible(formData: FormData): Observable<number> {
    return this.http.put<number>(this.removeUserResponsibleToGroupUlr ,formData, { headers: this.getHeaders() });
  }

  sendCaptura() {
    return this.http.post<any>(this.sendCapturaUrl, {"requestMode":"Manual"}, { headers: this.getHeaders() });
  }

  sendCapturaSelected(body: any) {
    return this.http.post<any>(this.sendCapturaSelectedUrl, body, { headers: this.getHeaders() });
  }

  generateCsvByCountryPeriod(mes: string, countryCode?: string) {
    let url = `${this.sendCapturaUrl}&mes=${encodeURIComponent(mes)}`;
    if (countryCode) {
      url += `&countryCode=${encodeURIComponent(countryCode)}`;
    }
    return this.http.post<any>(url, {"requestMode":"Manual"}, { headers: this.getHeaders() });
  }

  previewGenerateCsvByCountryPeriod(mes: string, countryCode?: string) {
    let url = `${this.sendCapturaUrl}&dryRun=true&mes=${encodeURIComponent(mes)}`;
    if (countryCode) {
      url += `&countryCode=${encodeURIComponent(countryCode)}`;
    }
    return this.http.post<any>(url, {"requestMode":"Manual"}, { headers: this.getHeaders() });
  }
/*
  getMedicoAttributes(nome: string, crm: string, especialidade: string) {
    let arrayAux = {
      nome: nome,
      matricula: crm,
      especialidade: especialidade
    };
    return this.http.post<any>(this.medicoAttributesUrl, arrayAux, { headers: this.getHeaders() });
  }
*/
  getMedicins(): Observable<string[]> {
    return this.http.post<string[]>(this.mediciUrl, { headers: this.getHeaders() });
  }

  findProdutoEs(body: any): Observable<any[]> {
    return this.http.post<any[]>(this.findProdutoEsUrl, body, { headers: this.getHeaders() });
  }

  getInstituicao(): Observable<string[]> {
    return this.http.get<string[]>(this.findInstituicaoUrl, { headers: this.getHeaders() });
  }

  findInstituicao(body: any): Observable<any[]> {
    return this.http.post<any[]>(this.findInstituicaoUrl, body, { headers: this.getHeaders() });
  }

  getEspecialidade(): Observable<string[]> {
    return this.http.get<string[]>(this.especialidadeUrl, { headers: this.getHeaders() });
  }

  getPosologia(): Observable<string[]> {
    return this.http.get<string[]>(this.posologiaUrl, { headers: this.getHeaders() });
  }

  getMedico(): Observable<string[]> {
    return this.http.get<string[]>(this.medicoUrl, { headers: this.getHeaders() });
  }

  findMedicoEs(body: any): Observable<any[]> {
    return this.http.post<any[]>(this.findMedicoUrl, body, { headers: this.getHeaders() });
  }

  getCRM(): Observable<string[]> {
    return this.http.get<string[]>(this.crmUrl, { headers: this.getHeaders() });
  }

  getEndereco(): Observable<string[]> {
    return this.http.get<string[]>(this.enderecoUrl, { headers: this.getHeaders() });
  }

  getGroupList() {
    return this.http.get<Group[]>(this.groupListUrl, { headers: this.getHeaders() });
  }

  getGroupListWithUserResp(email: string) {
    return this.http.get<Group[]>(this.groupListUserResptUrl + email, { headers: this.getHeaders() });
  }

  getUsersGroupList(groupId: string) {
    return this.http.get< any >(`${this.listarUsersUlr}?groupId=${groupId}`, { headers: this.getHeaders() });
  }

  getGroupDetail(groupId: string) {
    return this.http.get<Group>(`${this.groupDetailUrl}?id=${groupId}`, { headers: this.getHeaders() });
  }

  getGroupListUsers(groupId: string) {
    return this.http.get<GroupUser[]>(`${this.groupListUsersUrl}?groupId=${groupId}`, { headers: this.getHeaders() });
  }

  putGroupUpdateUrl(groupData: any): Observable<any> {
    return this.http.put<any>(this.groupUpdateUrl, groupData, { headers: this.getHeaders() });
  }

  removeGroup(formData: FormData): Observable<boolean> {
    return this.http.delete<boolean>(this.groupDeleteUrl, { headers: this.getHeaders(), body: formData });
  }

  toggleActiveGroup(payload: { id: string; isActive: boolean; updatedBy: string }): Observable<any> {
    return this.http.put<any>(this.groupToggleActiveUrl, payload, { headers: this.getHeaders() });
  }

  toggleActiveGroupCountryRegion(payload: { id: string; isActive: boolean; updatedBy: string }): Observable<any> {
    return this.http.put<any>(this.groupCrToggleActiveUrl, payload, { headers: this.getHeaders() });
  }

  toggleActiveGroupCountryRegionUser(payload: { groupCountryRegionId: string; userId: string; isActive: boolean; updatedBy: string }): Observable<any> {
    return this.http.put<any>(this.groupCrUserToggleActiveUrl, payload, { headers: this.getHeaders() });
  }

  checkGcruHasPrescriptionsPending(gcrId: string): Observable<{ hasPending: boolean }> {
    return this.http.get<{ hasPending: boolean }>(`${this.groupCrCheckPendingUrl}?gcrId=${gcrId}`, { headers: this.getHeaders() });
  }

  getStatus(): Observable<string[]> {
    return this.http.get<string[]>(this.statusUrl, { headers: this.getHeaders() });
  }

  getUserPermission() {
    return this.http.get<any>(this.userUrl, { headers: this.getHeaders() });
  }

  listCountry(): Observable<Country[]> {
    return this.http.get<Country[]>(this.countryListUrl, { headers: this.getHeaders() });
  }

  readCountry(id: string): Observable<Country> {
    return this.http.get<Country>(this.countryUrl + '?id=' + id, { headers: this.getHeaders() });
  }
  
  getRegiao(): Observable<Region[]> {
    return this.http.get<Region[]>(this.regiaoUrl, { headers: this.getHeaders() });
  }

  getRegiaoPorId(id: string): Observable<Region> {
    return this.http.get<Region>(this.regiaoIdUrl + '?id=' + id, { headers: this.getHeaders() });
  }

  getCidade(id: string): Observable<Region[]> {
    return this.http.get<Region[]>(this.regiaoUrl, { headers: this.getHeaders() });
  }

  getProvedor(): Observable<string[]> {
    return this.http.get<string[]>(this.provedorUrl, { headers: this.getHeaders() });
  }

  getItens(email: string) {
    return this.http.get<any>(this.itensUrl + email, { headers: this.getHeaders() });
  }

  getPaginatedData(params: HttpParams) {
    return this.http.get<PaginatedResponse<PrescriptionItem>>( this.itensApiUrl, { params, headers: this.getHeaders() } );
  }

  getNextPage(params: HttpParams) {
    return this.http.get<NextPrescriptionResponse>(this.itemNextUrl, { params, headers: this.getHeaders() });
  }

  getItem(id: string) {
    return this.http.get<PrescriptionResponse>(this.itemUrl + id, { headers: this.getHeaders() });
  }

  getImageItem(id: string) {
    return this.http.get(this.itemImageUrl + id, { headers: this.getHeaders(), responseType: 'blob' });
  }

  sendItem(formData: FormData) {
    return this.http.put<number>(this.putUrl ,formData, { headers: this.getHeaders() });
  }

  getPDVs(): Observable<string[]> {
    return this.http.get<string[]>(this.pdvUrl, { headers: this.getHeaders() });
  }

  getAno(): Observable<string[]> {
    return this.http.get<string[]>(this.anoUrl, { headers: this.getHeaders() });
  }

  getMes(): Observable<string[]> {
    return this.http.get<string[]>(this.mesUrl, { headers: this.getHeaders() });
  }

  getEnvio(): Observable<string[]> {
    return this.http.get<string[]>(this.envioUrl, { headers: this.getHeaders() });
  }

  getSearchFilename(search: string): Observable<string[]> {
    return this.http.get<string[]>(this.getSearchFilenameUrl + '?search=' + search, { headers: this.getHeaders() });
  }

  getSearchPdv(search: string): Observable<string[]> {
    return this.http.get<string[]>(this.getSearchPdvUrl + '?search=' + search, { headers: this.getHeaders() });
  }

  getDirectoryList(): Observable<Directory[]> {
    return this.http.get<Directory[]>(this.directoryListUrl, { headers: this.getHeaders() });
  }

  createDirectory(formData: FormData): Observable<Directory> {
    return this.http.post<Directory>(this.directoryCreateUrl, formData, { headers: this.getHeaders() });
  }

  getDirectoryDetail(id: string): Observable<Directory> {
    return this.http.get<Directory>(this.directoryDetailUrl + '?id=' + id, { headers: this.getHeaders() });
  }

  listMonthFolders(rootPath: string, filterYear: number): Observable<string[]> {
    const params = new HttpParams().set('rootPath', rootPath).set('filterYear', filterYear.toString());
    return this.http.get<string[]>(this.directoryListMonthFoldersUrl, { params, headers: this.getHeaders() });
  }

  updateDirectory(formData: FormData): Observable<number> {
    return this.http.put<number>(this.directoryUpdateUrl, formData, { headers: this.getHeaders() });
  }

  getCountPdvs(countryId: string): Observable<number> {
    return this.http.get<any>(`${this.directoryCountPdvUrl}/${countryId}`, { headers: this.getHeaders() }).pipe(
      map(response => typeof response === 'number' ? response : response?.count ?? 0)
    );
  }


  deleteDirectory(formData: FormData): Observable<number> {
    return this.http.request<number>('DELETE', this.directoryDeleteUrl, { body: formData, headers: this.getHeaders() });
  }

  uploadDirectoryPdv(formData: FormData): Observable<number> {
    return this.http.post<number>(this.directoryUploadPdvUrl, formData, { headers: this.getHeaders() });
  }

  downloadPdvTemplate(): Observable<Blob> {
    return this.http.get(this.directoryDownloadPdvTemplateUrl, {
      headers: this.getHeaders(),
      responseType: 'blob'
    });
  }

  getPdvList(countryId?: string, search?: string, isActive?: boolean): Observable<PrescriptionPdv[]> {
    let params = new HttpParams();
    if (countryId) params = params.append('countryId', countryId);
    if (search) params = params.append('search', search);
    if (isActive !== undefined) params = params.append('isActive', isActive.toString());
    return this.http.get<PrescriptionPdv[]>(this.pdvListUrl, { headers: this.getHeaders(), params });
  }

  getPdvDetail(id: string): Observable<PrescriptionPdv> {
    return this.http.get<PrescriptionPdv>(this.pdvDetailUrl + '?id=' + id, { headers: this.getHeaders() });
  }

  createPdv(formData: FormData): Observable<PrescriptionPdv> {
    return this.http.post<PrescriptionPdv>(this.pdvCreateUrl, formData, { headers: this.getHeaders() });
  }

  updatePdv(formData: FormData): Observable<PrescriptionPdv> {
    return this.http.put<PrescriptionPdv>(this.pdvUpdateUrl, formData, { headers: this.getHeaders() });
  }

  deletePdv(formData: FormData): Observable<boolean> {
    return this.http.request<boolean>('DELETE', this.pdvDeleteUrl, { body: formData, headers: this.getHeaders() });
  }

  uploadPdv(formData: FormData): Observable<boolean> {
    return this.http.post<boolean>(this.pdvUploadUrl, formData, { headers: this.getHeaders() });
  }

  downloadPdvCadastroTemplate(): Observable<Blob> {
    return this.http.get(this.pdvDownloadTemplateUrl, {
      headers: this.getHeaders(),
      responseType: 'blob'
    });
  }

  getUserPerformanceTracking(params?: HttpParams): Observable<any[]> {
    let url = this.userPerformanceTrackingUrl;
    if (params) {
      return this.http.get<any[]>(url, { headers: this.getHeaders(), params: params });
    }
    return this.http.get<any[]>(url, { headers: this.getHeaders() });
  }

  getUserPrescriptionCountryReviews(params?: HttpParams): Observable<any[]> {
    let url = this.userPrescriptionsCountryReviewerUrl;
    if (params) {
      return this.http.get<any[]>(url, { headers: this.getHeaders(), params: params });
    }
    return this.http.get<any[]>(url, { headers: this.getHeaders() });
  }

  getPais(): Observable<string[]> {
    return this.http.get<string[]>(this.prescriptionPaisUrl, { headers: this.getHeaders() });
  }

  getMonitoramentoProcessos(params?: HttpParams): Observable<any> {
    if (params) {
      return this.http.get<any>(this.monitoramentoProcessosUrl, { headers: this.getHeaders(), params });
    }
    return this.http.get<any>(this.monitoramentoProcessosUrl, { headers: this.getHeaders() });
  }

  getDashboardPrescricoesPorPais(params?: HttpParams): Observable<any[]> {
    if (params) {
      return this.http.get<any[]>(this.dashboardPrescricoesUrl, { headers: this.getHeaders(), params });
    }
    return this.http.get<any[]>(this.dashboardPrescricoesUrl, { headers: this.getHeaders() });
  }

  getDashboardRevisadasPorPais(params?: HttpParams): Observable<any[]> {
    if (params) {
      return this.http.get<any[]>(this.dashboardRevisadasUrl, { headers: this.getHeaders(), params });
    }
    return this.http.get<any[]>(this.dashboardRevisadasUrl, { headers: this.getHeaders() });
  }

  getDashboardPrescricoesPorMes(params?: HttpParams): Observable<any[]> {
    if (params) {
      return this.http.get<any[]>(this.dashboardPrescricoesMesUrl, { headers: this.getHeaders(), params });
    }
    return this.http.get<any[]>(this.dashboardPrescricoesMesUrl, { headers: this.getHeaders() });
  }

  getDashboardRevisadasPorMes(params?: HttpParams): Observable<any[]> {
    if (params) {
      return this.http.get<any[]>(this.dashboardRevisadasMesUrl, { headers: this.getHeaders(), params });
    }
    return this.http.get<any[]>(this.dashboardRevisadasMesUrl, { headers: this.getHeaders() });
  }

  getDashboardRevisadasPorRevisor(params?: HttpParams): Observable<any[]> {
    if (params) {
      return this.http.get<any[]>(this.dashboardRevisadasRevisorUrl, { headers: this.getHeaders(), params });
    }
    return this.http.get<any[]>(this.dashboardRevisadasRevisorUrl, { headers: this.getHeaders() });
  }

  getDashboardResumoBatchMes(params: HttpParams): Observable<any[]> {
    return this.http.get<any[]>(this.dashboardResumoBatchMesUrl, { headers: this.getHeaders(), params });
  }

  getDashboardResumoBatchPdv(params: HttpParams): Observable<any[]> {
    return this.http.get<any[]>(this.dashboardResumoBatchPdvUrl, { headers: this.getHeaders(), params });
  }

  carregarRelatorioIntervencoes(params: HttpParams): Observable<void> {
    return this.http.post<void>(this.dashboardRelatorioIntervencoesUrl + '/carregar', null, { headers: this.getHeaders(), params });
  }

  getDashboardRelatorioIntervencoes(params: HttpParams): Observable<any[]> {
    return this.http.get<any[]>(this.dashboardRelatorioIntervencoesUrl, { headers: this.getHeaders(), params });
  }

  getListPrescriptionsPendentes(params: HttpParams) {
    return this.http.get<PaginatedResponse<PrescriptionItem>>( this.itensApiPendentesUrl, { params, headers: this.getHeaders() } );
  }
 
  getNextPagePrescriptionsPendentes(params: HttpParams) {
    return this.http.get<NextPrescriptionValidacaoPendentesItemResponse>( this.itemNextPendentesUrl, { params, headers: this.getHeaders() } );
  }

  listPrescriptionImportErrors(params: HttpParams) {
    return this.http.get<PaginatedResponse<PrescriptionImportErrorListItem>>(this.prescriptionImportBatchListWithErrorUrl, { params, headers: this.getHeaders() });
  }

  downloadPrescriptionImportBatch(id: string): Observable<Blob> {
    return this.http.get(this.prescriptionImportBatchDownloadUrl + id + '/download', { headers: this.getHeaders(), responseType: 'blob' });
  }

  readValidacaoPrescriptionPendentes(id: string) {
    return this.http.get<PrescriptionValidacaoPendentesItemResponse>(this.itemValidacaoPendentesUrl + '?id=' + id, { headers: this.getHeaders() });
  }

}
